// Ошибка запроса к API → статус и текст для error() страницы Nuxt.
//
// Раньше каждая страница ловила ошибку по-своему: одни отдавали 404 на всё
// подряд (и 500 от бэка превращался в «Не найдено»), другие перечисляли
// статусы switch'ем. Здесь — одно правило: статус берём из ответа, без
// ответа (сеть, таймаут) — 500.

const MESSAGES: Record<number, string> = {
  400: 'Bad Request',
  403: 'Forbidden',
  404: 'Not Found',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
}

export function apiErrorStatus(err: unknown): number {
  const status =
    err && typeof err === 'object'
      ? (err as { response?: { status?: number } }).response?.status
      : undefined
  return status && status >= 400 ? status : 500
}

// eventId — ID события в GlitchTip, его ставит перехватчик axios
// (plugins/axios.ts). Страница ошибки показывает его пользователю.
export function apiError(err: unknown): {
  statusCode: number
  message: string
  eventId?: string
} {
  const statusCode = apiErrorStatus(err)
  const eventId =
    err && typeof err === 'object'
      ? (err as { sentryEventId?: string }).sentryEventId
      : undefined
  return { statusCode, message: MESSAGES[statusCode] || 'Error', eventId }
}
